import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { setSolutionJson, setUserParam } from '../../../actions';
import { StyledSelectInput } from '../../Wizard/Global/WizardStyled';
import { isProdEnv } from '../../../utils/helpers';
import withTranslation from '../../../hoc/withTranslation';
import { APP_MODES, getAppMode } from '../../../utils/urlHelpers';

const isProd = isProdEnv();
const showCustom = getAppMode().includes(APP_MODES.CUSTOM_URL);

const StaticSelectValue = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  font-size: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: #0f1621;
  color: #22cdc8;
  border-radius: 4px;
  user-select: text;
`;

const TpaSelector = ({ user, disabled, translations }) => {
  const {
    menu: { customOption, disabledRequestTypeInfo },
  } = translations;
  const dispatch = useDispatch();
  const usageContext = useSelector(({ usageContext: stateUsageContext }) => stateUsageContext);
  const solution = useSelector(({ solution: stateSolution }) => stateSolution);

  const handleSetUserParam = useCallback(
    (version) => dispatch(setUserParam({ tpaVersion: { ...user.tpaVersion, version } })),
    [dispatch, user.tpaVersion],
  );
  const handleSetSolutionJson = useCallback(
    (param) => dispatch(setSolutionJson(param)),
    [dispatch],
  );

  const onChange = useCallback(
    (e) => {
      handleSetUserParam(e.target.value);
      if (e.target.value !== 'custom' && solution.json && usageContext.currentStep !== 1)
        handleSetSolutionJson({ jsonUserChange: true });
    },
    [handleSetUserParam, handleSetSolutionJson, solution.json, usageContext.currentStep],
  );

  if (isProd) {
    return (
      <StaticSelectValue
        data-testid="tpVersionDropdown"
        title={disabled ? disabledRequestTypeInfo : undefined}
      >
        TP V3
      </StaticSelectValue>
    );
  }

  return (
    <StyledSelectInput
      data-testid="tpVersionDropdown"
      contrast
      sizeL
      onChange={onChange}
      value={user.tpaVersion.version}
      disabled={disabled}
      title={disabled ? disabledRequestTypeInfo : undefined}
    >
      <option value="prod">TP V3</option>
      {(!isProd || showCustom) && <option value="custom">{customOption}</option>}
    </StyledSelectInput>
  );
};

export default withTranslation(TpaSelector);
